import Model from './model';

export default class LogicBaseComment extends Model {
  constructor(_id, createdTime, owner, app, comment, text, likes, appType) {
    super();
    this._id = _id;
    this.createdTime = createdTime;
    this.owner = owner;
    this.app = app;
    this.comment = comment;
    this.text = text;
    this.likes = likes || 0;
    this.appType = appType;
  }
  get isCollection() {
    return this.appType === 'Collection';
  }
  getJson = () => {
    const { _id, owner, app, comment, text, appType } = this;
    return {
      _id,
      o: owner,
      a: app,
      c: comment,
      t: text,
      at: appType
    }
  }
}
